module.exports = __webpack_public_path__ + "img/Weapon_244.3ef9a81c.png";